import { render, staticRenderFns } from "./ManageFiles.vue?vue&type=template&id=661b64e8"
import script from "./ManageFiles.vue?vue&type=script&lang=js"
export * from "./ManageFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports